var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    [
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.jig_no"
          ),
          "detail-value": [_vm.form["officeInfoOfficeNo"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.office_name"
          ),
          "detail-value": [_vm.form["officeInfoOfficeName"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.office_name_kana"
          ),
          "detail-value": [_vm.form["officeInfoOfficeNameKana"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.address"
          ),
          "detail-value": [
            "〒 " +
              _vm.form["officeInfoZip1"] +
              "-" +
              _vm.form["officeInfoZip2"],
            _vm.form["officeInfoAddress1"] +
              " " +
              _vm.form["officeInfoAddress2"] +
              " " +
              _vm.form["officeInfoAddress3"]
          ]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.email"
          ),
          "detail-value": [_vm.form["officeInfoTantosyaMail"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.tel"
          ),
          "detail-value": [_vm.form["officeInfoTel"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.company_no"
          ),
          "detail-value": [_vm.form["officeInfoCompanyNo"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.corporate_name"
          ),
          "detail-value": [_vm.form["officeInfoCorporateName"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.corporate_address"
          ),
          "detail-value": [
            "〒 " +
              _vm.form["officeInfoCorporateZip1"] +
              "-" +
              _vm.form["officeInfoCorporateZip2"],
            _vm.form["officeInfoCorporateAddress1"] +
              " " +
              _vm.form["officeInfoCorporateAddress2"] +
              " " +
              _vm.form["officeInfoCorporateAddress3"]
          ]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.request_company_name"
          ),
          "detail-value": [_vm.form["requestInfoCompanyName"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.request_office_name"
          ),
          "detail-value": [_vm.form["requestInfoOfficeName"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.request_tel"
          ),
          "detail-value": [_vm.form["requestInfoTel"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.request_address"
          ),
          "detail-value": [
            "〒 " +
              _vm.form["requestInfoZip1"] +
              "-" +
              _vm.form["requestInfoZip2"],
            _vm.form["requestInfoAddress1"] +
              " " +
              _vm.form["requestInfoAddress2"] +
              " " +
              _vm.form["requestInfoAddress3"]
          ]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.request_person"
          ),
          "detail-value": [
            _vm.form["requestInfoRequestPersonLastName"] +
              " " +
              _vm.form["requestInfoRequestPersonFirstName"]
          ]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.request_mail"
          ),
          "detail-value": [_vm.form["requestInfoRequestEmail"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.how_to_request"
          ),
          "detail-value": [_vm.form["requestInfoHowToRequest"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki.how_to_send"
          ),
          "detail-value": [_vm.form["requestInfoHowToSend"]]
        }
      }),
      _vm._v(" "),
      !_vm.readonlyMode
        ? _c(
            "v-row",
            { staticClass: "mt-3" },
            [
              _c(
                "v-col",
                {
                  staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                  attrs: { cols: "12", sm: "12", md: "4" }
                },
                [
                  _c(
                    "v-sheet",
                    {
                      staticClass: "pt-3 pb-3 align-center fixed-label-area",
                      attrs: { color: "grey lighten-3" }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "mb-0 font-weight-bold ml-4 fixed-label"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t(
                                  "view.sales_force.reflect.label.torihikisaki.id"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "mb-0 mt-0 pt-2 pb-0",
                  attrs: { cols: "12", sm: "8", md: "4" }
                },
                [
                  _c("v-text-field", {
                    staticClass: "mt-0 pt-0 pb-0",
                    attrs: {
                      "persistent-hint": "",
                      hint: _vm.$t(
                        "view.sales_force.reflect.hint.torihikisaki.id"
                      ),
                      placeholder: _vm.$t(
                        "view.sales_force.reflect.placeholder.torihikisaki.id"
                      ),
                      autocomplete: "off"
                    },
                    model: {
                      value: _vm.salesForceInfo.torihikisakiId,
                      callback: function($$v) {
                        _vm.$set(_vm.salesForceInfo, "torihikisakiId", $$v)
                      },
                      expression: "salesForceInfo.torihikisakiId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
                  attrs: { cols: "12", sm: "4", md: "4" }
                },
                [
                  _c("move-sales-force-button", {
                    attrs: {
                      "sales-force-id": _vm.salesForceInfo.torihikisakiId,
                      "sales-force-type": "Account"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.readonlyMode
        ? _c("sales-force-button-area", {
            on: {
              reflect: _vm.submit,
              "csv-output": _vm.csvOutput,
              "re-correct": _vm.reCorrect
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showConfirmDialog,
          "max-width": "800",
          "default-msg": _vm.confirmMessage
        },
        on: {
          "ok-click": function($event) {
            return _vm.reflect()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showAlertDialog,
          "max-width": "800",
          "is-confirm": false,
          "default-msg": _vm.$t(
            "view.sales_force.reflect.msg.alert_torihikisaki_id"
          )
        },
        on: {
          "ok-click": function($event) {
            return _vm.dialogClose()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-363e7ba4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-363e7ba4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales_force/Torihikisaki.vue
// module id = G2+J
// module chunks = 1